module.exports = __webpack_public_path__ + "img/d.84f02b2e.jpeg";